var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WorkerIdCard50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32,17H12c-1.105,0-2,0.895-2,2v14c0,1.105,0.895,2,2,2h20c1.105,0,2-0.895,2-2V19 C34,17.895,33.105,17,32,17z M12,31c0-2.112,1.314-3.909,3.166-4.642C14.461,25.809,14,24.962,14,24c0-1.657,1.343-3,3-3 s3,1.343,3,3c0,0.962-0.461,1.809-1.166,2.358C20.686,27.091,22,28.888,22,31H12z M31,31h-7v-2h7V31z M31,27h-7v-2h7V27z M31,23h-7 v-2h7V23z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36,13H16c-1.105,0-2,0.895-2,2h19c1.657,0,3,1.343,3,3v13c1.105,0,2-0.895,2-2V15 C38,13.895,37.105,13,36,13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WorkerIdCard50);
export default __webpack_public_path__ + "static/media/icons8-worker-id-card-50.2459bd599ef5ba3f0d894f581c514335.svg";
export { ForwardRef as ReactComponent };